import { FC } from 'react'
import { GuardsParam } from 'interfaces/guards'
import { feedMemberAuthGuard, peergroupsGuard, memberInfoGuard } from 'guards/globalGuards'
import PageLoadingOverlay from 'components/atoms/preloaders/PageLoadingOverlay'
import { connectLoadable, createParallelGuard, bindGuard } from 'helpers/loadableHelpers'
import { createSelector } from 'reselect'
import { currentPageSelector } from 'selectors/globalSelectors'
import { connect } from 'react-redux'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import SocialProfilePopupContainer from 'components/features/socialFeed/SocialProfilePopup/SocialProfilePopupContainer'
import { OptionalAuthGuard } from 'components/features/pfm/OptionalAuthGuard/OptionalAuthGuard'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { isAuthenticatedSelector } from 'selectors/globalSelectors'
import { createInsightsGuard } from 'guards/insightGuards'
import { StrippedFragment } from 'components/features/pfm/StrippedFragment/StrippedFragment'
import { randomFeedRelationGuard } from 'guards/feedGuards'


const createFeedPostsGuards: GuardsParam = () => [
  createParallelGuard(feedMemberAuthGuard, memberInfoGuard, randomFeedRelationGuard, peergroupsGuard),
  bindGuard(createInsightsGuard(), { placement: 'feedposts_general' }),
]

const RendererWithGuards = connectLoadable<{}, {}, {}, {}>(
  createFeedPostsGuards, PageLoadingOverlay
)(undefined)(StrippedFragment)

type FeedGuardStateProps = {
  currentPage: string
}

type FeedGuardProps = FeedGuardStateProps

const FeedGuardComponent: FC<FeedGuardProps> = ({
  currentPage,
  children,
}) => {
  const isAuthenticated = useStoreSelector(isAuthenticatedSelector)
  if (currentPage === 'feedposts') {

    if (isAuthenticated === null) {
      return <PageLoadingOverlay />
    }

    const FeedPostsGuard = isAuthenticated ? RendererWithGuards : StrippedFragment

    return (
      <FeedPostsGuard>
        <SocialProfilePopupContainer />
        { children }
      </FeedPostsGuard>
    )
  }

  return (
    <OptionalAuthGuard>
      <SocialProfilePopupContainer />
      { children }
    </OptionalAuthGuard>
  )
}

const mapStateToProps = createSelector(
  currentPageSelector,
  (currentPage) => ({
    currentPage,
  })
)

export const FeedGuard = withRouter(
  connect<
    FeedGuardStateProps, {}, RouteComponentProps<{}>
  >(mapStateToProps, () => ({}), undefined)(FeedGuardComponent)
)
